/**
 * @项目名称: work
 * @功能名称: 获取授权获取openid
 * @params: data= { accountKey: 'cardloan_gouwohua'} 微信jsAPI支付需要传这个accountKey进行授权
 * @文件名称: getWXUnionid
 * @Date: 2019/11/19
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */

import browsersInfo from '../helper/ySniff'
var browsers = browsersInfo.browsers
import getQueryString from '../helper/getQueryString'
import {post} from '../network/http';

function getWXUnionid(data,cb){
  if(typeof data === 'function'){
    cb = data
    data = {}
  }
  cb = (typeof cb === 'function')? cb : function () {}
  if(!browsers.wechat){
    return cb({errcode:-1,errstr:'非微信环境'})
  }
  const source = getQueryString('source')
  var params = Object.assign({
      _srcid: source,
      channel: source,
      source: source,
      redirectUrl: encodeURIComponent(location.href),
  },data);
   post('/h5/wechat/check_account_session',params).then((json)=>{
     cb(json)
  },json=>{
    if(/^http(s)?:\/\//.test(json.data.oauthUrl)){
      location.replace(json.data.oauthUrl)
    }else {
      cb(json)
    }
  })
}

export default getWXUnionid
